import {getIn} from 'formik'
import {FC} from 'react'
import {useIntl} from 'react-intl'

type LinkItem = {
  label: string
  onClick: () => void
}

type Props = {
  alignTop?: boolean
  className?: string
  checkboxClassName?: string
  linkClassName?: string
  labelCheck?: string | null
  splitLabelCheck?: string[]
  labelLink?: string | null
  formik: any
  name: any
  links?: LinkItem[]
}

const AcceptTermCheckbox: FC<Props> = ({
  alignTop = false,
  className,
  checkboxClassName,
  linkClassName,
  labelCheck = null,
  splitLabelCheck = [],
  labelLink = null,
  formik,
  name,
  links = [],
}) => {
  let fieldProps = formik.getFieldProps(name)
  let formikErrors = getIn(formik.errors, name)
  let formikTouched = getIn(formik.touched, name)
  const intl = useIntl()

  return (
    <div
      className={`fv-row fv-plugins-icon-container fv-plugins-bootstrap5-row-invalid ${className}`}
    >
      <div
        className={`form-check form-check-custom form-check-solid form-check-inline ${
          alignTop ? 'align-items-start' : ''
        }`}
      >
        <input
          className={`form-check-input shadow-none ${alignTop ? 'mt-1' : ''}`}
          type='checkbox'
          checked={fieldProps.value}
          {...fieldProps}
        />
        <span className={`form-check-label fw-bold text-gray-700 fs-7 ${checkboxClassName}`}>
          {splitLabelCheck.length > 0 && !labelCheck && (
            <p>
              {splitLabelCheck.length >= 2 && links.length > 0 && (
                <>
                  <span>{splitLabelCheck[0]}</span>
                  {links.map((link, idx) => (
                    <span key={idx} className='ms-1'>
                      <span>
                        {idx === links.length - 1 && (
                          <>{' ' + intl.formatMessage({id: 'AND'}) + ' '}</>
                        )}
                      </span>
                      <span
                        className={`text-primary-deep text-hover-primary ${linkClassName} text-decoration-underline`}
                        role='link'
                        onClick={link.onClick}
                      >
                        {link.label}
                      </span>
                      <span>{idx === links.length - 1 && '.'}</span>
                      {idx < links.length - 1 && ', '}
                    </span>
                  ))}
                  <span className='ms-1'>{splitLabelCheck[1]}</span>
                </>
              )}
            </p>
          )}
          {splitLabelCheck.length === 0 && labelCheck && (
            <>
              {labelCheck}
              {links.map((link, index) => (
                <span
                  key={index}
                  className={`ms-1 text-primary-deep text-hover-primary ${linkClassName}`}
                  role='link'
                  onClick={link.onClick}
                >
                  {link.label} {index < links.length - 1 && ' | '}
                </span>
              ))}
            </>
          )}
        </span>
      </div>
      {formikTouched && formikErrors && (
        <div className='fv-plugins-message-container mt-2'>
          <div className='fv-help-block text-danger'>
            <span role='alert'>{formikErrors}</span>
          </div>
        </div>
      )}
    </div>
  )
}

export {AcceptTermCheckbox}
